module.exports = __webpack_public_path__ + "img/fingerprint-scanner-1.33d56b0b.svg";